(() => {
  if (window.HumanPrimeHomeNarrative) {
    window.HumanPrimeHomeNarrative.scan(document);
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsObserver = 'IntersectionObserver' in window;
  const sectionElements = new WeakMap();

  const observer = !reducedMotion && supportsObserver
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-narrative-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 })
    : null;

  const unique = (elements) => Array.from(new Set(elements.filter(Boolean)));

  const elementsForSection = (root) => {
    if (root.matches('[data-home-narrative-catalog]')) {
      return unique([
        ...root.querySelectorAll('.hp-section-heading > *'),
        root.querySelector('.catalog__footer')
      ]);
    }

    if (root.classList.contains('quality-guarantee')) {
      return unique([
        root.querySelector('.hp-narrative-decor'),
        root.querySelector('.quality-guarantee__visual'),
        root.querySelector('.quality-guarantee__content > h2'),
        root.querySelector('.quality-guarantee__body'),
        ...root.querySelectorAll('.guarantee-item')
      ]);
    }

    if (root.classList.contains('research-experience')) {
      return unique([
        root.querySelector('.hp-narrative-decor'),
        root.querySelector('.research-experience__heading'),
        ...root.querySelectorAll('.icon-card')
      ]);
    }

    if (root.classList.contains('why-human-prime')) {
      return unique([
        root.querySelector('.hp-narrative-decor'),
        root.querySelector('.why-human-prime__heading'),
        ...root.querySelectorAll('.pastel-card')
      ]);
    }

    if (root.classList.contains('faq')) {
      return unique([
        root.querySelector('.hp-narrative-decor'),
        ...root.querySelectorAll('.hp-section-heading > *'),
        ...root.querySelectorAll('.faq-item')
      ]);
    }

    if (root.classList.contains('cta-banner')) {
      return unique([
        root.querySelector('.hp-narrative-decor'),
        ...root.querySelectorAll('.cta-banner__decor'),
        root.querySelector('.cta-banner__heading'),
        root.querySelector('.cta-banner__actions')
      ]);
    }

    if (root.classList.contains('newsletter')) {
      return unique([
        root.querySelector('.hp-narrative-decor'),
        root.querySelector('.newsletter__card')
      ]);
    }

    return [];
  };

  const initialize = (root) => {
    if (!root || sectionElements.has(root)) return;
    const elements = elementsForSection(root);
    sectionElements.set(root, elements);

    elements.forEach((element, index) => {
      element.dataset.homeReveal = '';
      element.style.setProperty('--hp-narrative-delay', `${Math.min(index, 7) * 65}ms`);
      if (observer) observer.observe(element);
      else element.classList.add('is-narrative-visible');
    });
  };

  const destroy = (root) => {
    if (!root) return;
    const elements = sectionElements.get(root) || [];
    elements.forEach((element) => observer?.unobserve(element));
    sectionElements.delete(root);
  };

  const scan = (scope) => {
    const roots = [];
    if (scope.matches?.('[data-home-narrative], [data-home-narrative-catalog]')) roots.push(scope);
    roots.push(...(scope.querySelectorAll?.('[data-home-narrative], [data-home-narrative-catalog]') || []));
    roots.forEach(initialize);
  };

  window.HumanPrimeHomeNarrative = { scan, destroy };
  if (observer) document.documentElement.classList.add('hp-narrative-motion');
  scan(document);

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.('[data-home-narrative], [data-home-narrative-catalog]')
      ? event.target
      : event.target.querySelector?.('[data-home-narrative], [data-home-narrative-catalog]');
    destroy(root);
  });
})();
